require('sass/brands/stores.nordstromrack.com/directory/default.scss');
require('js/locationList-script.js');
